import { z } from 'zod';
// ---------- Enums ----------
export const CourtNotificationTypeSchema = z.enum([
    'SENTENCIA',
    'AUTO',
    'PROVIDENCIA',
    'DILIGENCIA_ORDENACION',
    'REQUERIMIENTO',
    'CITACION',
    'EMPLAZAMIENTO',
    'OFICIO',
    'OTRO',
]);
export const CourtNotificationTypeLabel = {
    SENTENCIA: 'Sentencia',
    AUTO: 'Auto',
    PROVIDENCIA: 'Providencia',
    DILIGENCIA_ORDENACION: 'Diligencia de ordenación',
    REQUERIMIENTO: 'Requerimiento',
    CITACION: 'Citación',
    EMPLAZAMIENTO: 'Emplazamiento',
    OFICIO: 'Oficio',
    OTRO: 'Otro',
};
export const CourtFilingKindSchema = z.enum([
    'DEMANDA',
    'CONTESTACION',
    'RECONVENCION',
    'RECURSO_REPOSICION',
    'RECURSO_APELACION',
    'RECURSO_CASACION',
    'ESCRITO_ORDINARIO',
    'ALEGACIONES',
    'PRUEBA',
    'COMPARECENCIA',
    'PROVISION_FONDOS',
    'OTRO',
]);
export const CourtFilingKindLabel = {
    DEMANDA: 'Demanda',
    CONTESTACION: 'Contestación',
    RECONVENCION: 'Reconvención',
    RECURSO_REPOSICION: 'Recurso de reposición',
    RECURSO_APELACION: 'Recurso de apelación',
    RECURSO_CASACION: 'Recurso de casación',
    ESCRITO_ORDINARIO: 'Escrito ordinario',
    ALEGACIONES: 'Alegaciones',
    PRUEBA: 'Proposición de prueba',
    COMPARECENCIA: 'Comparecencia',
    PROVISION_FONDOS: 'Provisión de fondos',
    OTRO: 'Otro',
};
export const CourtFilingStatusSchema = z.enum([
    'BORRADOR',
    'ENVIADO_A_PROCURADOR',
    'PRESENTADO',
    'ACEPTADO',
    'RECHAZADO',
    'RESUELTO',
]);
export const CourtFilingStatusLabel = {
    BORRADOR: 'Borrador',
    ENVIADO_A_PROCURADOR: 'Enviado al procurador',
    PRESENTADO: 'Presentado',
    ACEPTADO: 'Aceptado',
    RECHAZADO: 'Rechazado',
    RESUELTO: 'Resuelto',
};
export const AutonomousCommunitySchema = z.enum([
    'ES_AN', 'ES_AR', 'ES_AS', 'ES_CN', 'ES_CB', 'ES_CL', 'ES_CM',
    'ES_CT', 'ES_EX', 'ES_GA', 'ES_IB', 'ES_RI', 'ES_MD', 'ES_MC',
    'ES_NC', 'ES_PV', 'ES_VC', 'ES_CE', 'ES_ML',
]);
export const AutonomousCommunityLabel = {
    ES_AN: 'Andalucía',
    ES_AR: 'Aragón',
    ES_AS: 'Asturias',
    ES_CN: 'Canarias',
    ES_CB: 'Cantabria',
    ES_CL: 'Castilla y León',
    ES_CM: 'Castilla-La Mancha',
    ES_CT: 'Cataluña',
    ES_EX: 'Extremadura',
    ES_GA: 'Galicia',
    ES_IB: 'Illes Balears',
    ES_RI: 'La Rioja',
    ES_MD: 'Madrid',
    ES_MC: 'Murcia',
    ES_NC: 'Navarra',
    ES_PV: 'País Vasco',
    ES_VC: 'Comunidad Valenciana',
    ES_CE: 'Ceuta',
    ES_ML: 'Melilla',
};
// ---------- Procurador ----------
export const CourtAgentDtoSchema = z.object({
    id: z.string(),
    fullName: z.string(),
    legalName: z.string().nullable(),
    nationalId: z.string().nullable(),
    collegeName: z.string().nullable(),
    collegeNumber: z.string().nullable(),
    judicialDistrict: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    mobile: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postalCode: z.string().nullable(),
    province: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
    activeCasesCount: z.number().int(),
});
export const CreateCourtAgentSchema = z.object({
    fullName: z.string().min(2).max(200),
    legalName: z.string().max(200).nullable().optional(),
    nationalId: z.string().max(20).nullable().optional(),
    collegeName: z.string().max(120).nullable().optional(),
    collegeNumber: z.string().max(20).nullable().optional(),
    judicialDistrict: z.string().max(120).nullable().optional(),
    email: z.union([z.string().email(), z.literal('')]).nullable().optional(),
    phone: z.string().max(30).nullable().optional(),
    mobile: z.string().max(30).nullable().optional(),
    address: z.string().max(300).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    postalCode: z.string().max(10).nullable().optional(),
    province: z.string().max(100).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
export const UpdateCourtAgentSchema = CreateCourtAgentSchema.partial();
export const CourtAgentListResponseSchema = z.object({
    items: z.array(CourtAgentDtoSchema),
});
// ---------- Notificación judicial ----------
export const CourtNotificationDtoSchema = z.object({
    id: z.string(),
    caseId: z.string(),
    caseCode: z.string(),
    caseTitle: z.string(),
    type: CourtNotificationTypeSchema,
    title: z.string(),
    description: z.string().nullable(),
    notifiedAt: z.string().datetime(),
    jurisdiction: z.string().nullable(),
    deadlineDays: z.number().int().nullable(),
    deadlineDate: z.string().datetime().nullable(),
    isComplied: z.boolean(),
    compliedAt: z.string().datetime().nullable(),
    attachmentKey: z.string().nullable(),
    attachmentName: z.string().nullable(),
    calendarEventId: z.string().nullable(),
    createdAt: z.string().datetime(),
    createdByName: z.string().nullable(),
});
export const CreateCourtNotificationSchema = z.object({
    caseId: z.string(),
    type: CourtNotificationTypeSchema,
    title: z.string().min(2).max(300),
    description: z.string().max(5000).nullable().optional(),
    notifiedAt: z.string().refine((v) => !Number.isNaN(Date.parse(v)), 'Fecha no válida'),
    jurisdiction: z.string().max(40).nullable().optional(),
    deadlineDays: z.coerce.number().int().min(0).max(365).nullable().optional(),
    /** Si se prefiere fijar la fecha manualmente (no recalcula con días hábiles). */
    deadlineDate: z.string().nullable().optional(),
});
export const UpdateCourtNotificationSchema = z.object({
    title: z.string().min(2).max(300).optional(),
    description: z.string().max(5000).nullable().optional(),
    type: CourtNotificationTypeSchema.optional(),
    notifiedAt: z
        .string()
        .refine((v) => !Number.isNaN(Date.parse(v)), 'Fecha no válida')
        .optional(),
    jurisdiction: z.string().max(40).nullable().optional(),
    deadlineDays: z.coerce.number().int().min(0).max(365).nullable().optional(),
    deadlineDate: z.string().nullable().optional(),
    isComplied: z.boolean().optional(),
});
export const CourtNotificationListResponseSchema = z.object({
    items: z.array(CourtNotificationDtoSchema),
});
// ---------- Escrito (CourtFiling) ----------
export const CourtFilingDtoSchema = z.object({
    id: z.string(),
    caseId: z.string(),
    caseCode: z.string(),
    caseTitle: z.string(),
    kind: CourtFilingKindSchema,
    title: z.string(),
    description: z.string().nullable(),
    status: CourtFilingStatusSchema,
    internalDueDate: z.string().datetime().nullable(),
    sentToAgentAt: z.string().datetime().nullable(),
    presentedAt: z.string().datetime().nullable(),
    resolvedAt: z.string().datetime().nullable(),
    documentKey: z.string().nullable(),
    documentName: z.string().nullable(),
    respondsToNotificationId: z.string().nullable(),
    respondsToNotificationTitle: z.string().nullable(),
    createdAt: z.string().datetime(),
    createdByName: z.string().nullable(),
});
export const CreateCourtFilingSchema = z.object({
    caseId: z.string(),
    kind: CourtFilingKindSchema,
    title: z.string().min(2).max(300),
    description: z.string().max(5000).nullable().optional(),
    internalDueDate: z.string().nullable().optional(),
    respondsToNotificationId: z.string().nullable().optional(),
});
export const UpdateCourtFilingSchema = z.object({
    title: z.string().min(2).max(300).optional(),
    description: z.string().max(5000).nullable().optional(),
    kind: CourtFilingKindSchema.optional(),
    internalDueDate: z.string().nullable().optional(),
    respondsToNotificationId: z.string().nullable().optional(),
});
export const CourtFilingListResponseSchema = z.object({
    items: z.array(CourtFilingDtoSchema),
});
// ---------- Bandeja unificada de vencimientos ----------
export const DeadlineItemSchema = z.object({
    /** Tipo de origen: notificación judicial o escrito interno. */
    source: z.enum(['NOTIFICATION', 'FILING']),
    id: z.string(),
    caseId: z.string(),
    caseCode: z.string(),
    caseTitle: z.string(),
    title: z.string(),
    /** Para NOTIFICATION: tipo legal. Para FILING: kind. */
    subtype: z.string(),
    date: z.string().datetime(),
    /** Días hasta el vencimiento (negativo si ya vencido). */
    daysUntil: z.number().int(),
    isOverdue: z.boolean(),
    isComplied: z.boolean(),
});
export const DeadlineListResponseSchema = z.object({
    items: z.array(DeadlineItemSchema),
});
// ---------- Festivos ----------
export const CourtHolidayDtoSchema = z.object({
    id: z.string(),
    date: z.string(),
    description: z.string(),
    community: AutonomousCommunitySchema.nullable(),
});
export const CreateCourtHolidaySchema = z.object({
    date: z.string().refine((v) => /^\d{4}-\d{2}-\d{2}$/.test(v), 'Formato YYYY-MM-DD'),
    description: z.string().min(1).max(200),
    community: AutonomousCommunitySchema.nullable().optional(),
});
//# sourceMappingURL=litigation.js.map